import { ComponentType } from 'react';
import { FormNode } from '../utils/api/aboboApiTypes';

export interface QuestionTypeComponent {
  component: ComponentType<{ node: FormNode; ref?: any }>;
  name: string;
}

class QuestionTypeRegistry {
  private registry: Map<string, QuestionTypeComponent> = new Map();

  register(nodeSubtype: string, component: QuestionTypeComponent) {
    this.registry.set(nodeSubtype, component);
  }

  get(nodeSubtype: string): QuestionTypeComponent | undefined {
    return this.registry.get(nodeSubtype);
  }

  getAll(): Map<string, QuestionTypeComponent> {
    return this.registry;
  }
}

export const questionTypeRegistry = new QuestionTypeRegistry();
